<div class="p-5">
  <div class="flex justify-between items-center mb-2">
    <div class="text-lg text-gray-700 font-bold">Recusar atribuição</div>
    <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="text-sm text-gray-500 mb-4">
    TG {{ data.item.codigoTg }} · OS {{ data.item.codigoOs }}
  </div>

  <div [formGroup]="form" class="flex flex-col gap-1">
    <mat-form-field class="input-tg w-full px-2" appearance="outline">
      <mat-label>Motivo</mat-label>
      <textarea matInput formControlName="motivo" rows="3" placeholder="O fornecedor vai ler este texto no portal."></textarea>
    </mat-form-field>
  </div>

  <div class="flex justify-end gap-2 mt-4">
    <button mat-flat-button class="btn-tg-white" (click)="close()">Cancelar</button>
    <button mat-flat-button class="btn-tg" [disabled]="form.invalid || saving" (click)="recusar()">
      @if (saving) {
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
      } @else {
        Recusar atribuição
      }
    </button>
  </div>
</div>
